import React from 'react';
import { ParticleBackground } from '../components/ParticleBackground';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { OfferSection } from '../components/OfferSection';
import { ServicesSection } from '../components/ServicesSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ResultsSection } from '../components/ResultsSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { ChatWidget } from '../components/ChatWidget';
export function LandingPage() {
  return <div className="min-h-screen bg-white text-black selection:bg-primary selection:text-white relative" data-id="element-582">
      <ParticleBackground data-id="element-583" />
      <Navigation data-id="element-584" />

      <main data-id="element-585">
        <HeroSection data-id="element-586" />
        <ProblemSection data-id="element-587" />
        <SolutionSection data-id="element-588" />
        <OfferSection data-id="element-589" />
        <ServicesSection data-id="element-590" />
        <HowItWorksSection data-id="element-591" />
        <ResultsSection data-id="element-592" />
        <PricingSection data-id="element-593" />
        <FAQSection data-id="element-594" />
        <FinalCTASection data-id="element-595" />
      </main>

      <Footer data-id="element-596" />
      <ChatWidget data-id="element-597" />
    </div>;
}